/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CalendarBookingRequest,
  CalendarEvent,
  CalendarEventRequest,
  CalendarEventResponse,
} from '../models/index';
import {
    CalendarBookingRequestFromJSON,
    CalendarBookingRequestToJSON,
    CalendarEventFromJSON,
    CalendarEventToJSON,
    CalendarEventRequestFromJSON,
    CalendarEventRequestToJSON,
    CalendarEventResponseFromJSON,
    CalendarEventResponseToJSON,
} from '../models/index';

export interface AccessMeetingRequest {
    eventId?: string;
    returnUrl?: string;
}

export interface CancelCalendarEventRequest {
    calendarEventRequest?: CalendarEventRequest;
}

export interface GetCalendarEventStatusRequest {
    eventId?: string;
}

export interface SendBookingAsEmailRequest {
    calendarBookingRequest?: CalendarBookingRequest;
}

export interface SendCancelMeetingEmailRequest {
    cancelBodyText?: string;
    meetingId?: string;
    organiserEmail?: string;
}

export interface SignForEventRequest {
    calendarEventRequest?: CalendarEventRequest;
}

/**
 * 
 */
export class CalendarEventApi extends runtime.BaseAPI {

    /**
     */
    async accessMeetingRaw(requestParameters: AccessMeetingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        if (requestParameters.returnUrl !== undefined) {
            queryParameters['returnUrl'] = requestParameters.returnUrl;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CalendarEventApi/AccessMeeting`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async accessMeeting(requestParameters: AccessMeetingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.accessMeetingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cancelCalendarEventRaw(requestParameters: CancelCalendarEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalendarEventResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/CalendarEventApi/CancelCalendarEvent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CalendarEventRequestToJSON(requestParameters.calendarEventRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalendarEventResponseFromJSON(jsonValue));
    }

    /**
     */
    async cancelCalendarEvent(requestParameters: CancelCalendarEventRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalendarEventResponse> {
        const response = await this.cancelCalendarEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCalendarEventStatusRaw(requestParameters: GetCalendarEventStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalendarEventResponse>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CalendarEventApi/GetCalendarEventStatus`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalendarEventResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCalendarEventStatus(requestParameters: GetCalendarEventStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalendarEventResponse> {
        const response = await this.getCalendarEventStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMemberEventsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalendarEvent>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CalendarEventApi/GetMemberEvents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CalendarEventFromJSON));
    }

    /**
     */
    async getMemberEvents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalendarEvent>> {
        const response = await this.getMemberEventsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async sendBookingAsEmailRaw(requestParameters: SendBookingAsEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/CalendarEventApi/SendBookingAsEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CalendarBookingRequestToJSON(requestParameters.calendarBookingRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendBookingAsEmail(requestParameters: SendBookingAsEmailRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendBookingAsEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async sendCancelMeetingEmailRaw(requestParameters: SendCancelMeetingEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.cancelBodyText !== undefined) {
            queryParameters['cancelBodyText'] = requestParameters.cancelBodyText;
        }

        if (requestParameters.meetingId !== undefined) {
            queryParameters['meetingId'] = requestParameters.meetingId;
        }

        if (requestParameters.organiserEmail !== undefined) {
            queryParameters['organiserEmail'] = requestParameters.organiserEmail;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CalendarEventApi/SendCancelMeetingEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendCancelMeetingEmail(requestParameters: SendCancelMeetingEmailRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendCancelMeetingEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async signForEventRaw(requestParameters: SignForEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalendarEventResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/CalendarEventApi/SignForEvent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CalendarEventRequestToJSON(requestParameters.calendarEventRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalendarEventResponseFromJSON(jsonValue));
    }

    /**
     */
    async signForEvent(requestParameters: SignForEventRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalendarEventResponse> {
        const response = await this.signForEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
